import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div aria-hidden className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
  );
}

export function Spinner({ className, label = 'Loading' }: { className?: string; label?: string }) {
  return (
    <span
      role="status"
      className={cn(
        'inline-block size-4 animate-spin rounded-full border-2 border-current border-r-transparent text-muted-foreground',
        className,
      )}
    >
      <span className="sr-only">{label}</span>
    </span>
  );
}

/** Thin bar for background refetches, so content doesn't jump to a skeleton. */
export function LoadingBar({ active }: { active: boolean }) {
  if (!active) return null;
  return (
    <div
      className="absolute inset-x-0 top-0 h-0.5 overflow-hidden"
      role="progressbar"
      aria-label="Loading"
    >
      <div className="h-full w-1/3 animate-indeterminate bg-primary" />
    </div>
  );
}
